// extracted by mini-css-extract-plugin
export default {"ModalBackground":"ModalBackground_ModalBackground__cxvn3","VisibleModalBackground":"ModalBackground_VisibleModalBackground__EFWqk"};